<template>
    <va-edit-layout>
        <FBALiquidationEvent-form
            :id="id"
            :title="title"
            :item="item"
        ></FBALiquidationEvent-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
